exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".color_AAA[data-v-1d21e5c8]{color:#aaa}", ""]);

// exports
